import { createSlice } from '@reduxjs/toolkit';
import { find } from 'lodash';
import { createSelector } from 'reselect';

const initialState = {
  partners: [],
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  loading: false,
  isPartnerCreated: false,
  isPartnerEdited: false,
  selectedPartner: {},
  error: null,
};

const partnerSlice = createSlice({
  name: 'partners',
  initialState,
  reducers: {
    fetchPartnersRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchPartnersSuccess(state, action) {
      state.loading = false;
      state.partners = action.payload.users || [];
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalCount = action.payload.totalCount;
    },
    fetchPartnersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchPartnerById(state) {
      state.loading = true;
      state.error = null;
    },
    fetchPartnerByIdSuccess(state, action) {
      const partner = action.payload;
      let found = find(state.partners, { _id: partner._id });
      if (!found) {
        state.partners.push(partner);
      }

      state.loading = false;
      state.selectedPartner = action.payload;
    },
    clearSelectedPartner(state) {
      state.selectedPartner = undefined;
    },
    fetchPartnerByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    createPartnerRequest(state) {
      state.loading = true;
      state.error = null;
      state.isPartnerCreated = false;
    },
    editPartnerRequest(state) {
      state.loading = true;
      state.error = null;
      state.isPartnerEdited = false;
    },
    createPartnerSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isPartnerCreated = true;
    },
    editPartnerFailure(state, action) {
      state.loading = false;
      state.isPartnerEdited = false;
      state.error = action.payload;
    },
    editPartnerSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isPartnerEdited = true;
    },
    createPartnerFailure(state, action) {
      state.loading = false;
      state.isPartnerCreated = false;
      state.error = action.payload;
    },
    cancelPartnerCreate(state) {
      state.loading = false;
      state.error = null;
      state.isPartnerCreated = false;
      state.isPartnerEdited = false;
    },
    markPartnerCreated(state, action) {
      state.isPartnerCreated = action.payload;
    },
    markPartnerEdited(state, action) {
      state.isPartnerEdited = action.payload;
    },
  },
});

export const {
  fetchPartnersRequest,
  fetchPartnersSuccess,
  fetchPartnersFailure,
  fetchPartnerById,
  fetchPartnerByIdSuccess,
  fetchPartnerByIdFailure,
  createPartnerRequest,
  createPartnerSuccess,
  createPartnerFailure,
  editPartnerRequest,
  editPartnerFailure,
  editPartnerSuccess,
  markPartnerCreated,
  markPartnerEdited,
  cancelPartnerCreate,
  clearSelectedPartner,
} = partnerSlice.actions;

const partnerState = (state) => state.partners;

export const selectPartnerById = (id) =>
  createSelector([partnerState], (partnerState) => partnerState.partners.find((partner) => partner._id === id) || {});

export default partnerSlice.reducer;
